import script from "./HotArticles.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotArticles.vue?vue&type=script&lang=ts&setup=true"

import "./HotArticles.vue?vue&type=style&index=0&id=5eccdced&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eccdced"]])

export default __exports__